export function parseSampling(value: string, min = 0, max = 1): number | undefined {
  const target = parseFloat(value);
  if (Number.isNaN(target)) {
    return undefined;
  }
  if (!Number.isFinite(target)) {
    return undefined;
  }
  if (target > max) {
    return max;
  }
  if (target <= min) {
    return min;
  }
  return target;
}
